export default __webpack_public_path__ + "static/media/empty-message-box.1a2de797.svg";